export default {
  "discover_your": "ನಿಮ್ಮ",
  "ascendant": "ಲಗ್ನವನ್ನು ಅನ್ವೇಷಿಸಿ",
  "rising_sign_analysis": "ಉದಯ ರಾಶಿ ವಿಶ್ಲೇಷಣೆ",
  "ascendant_description": "ಇದು ನಿಮ್ಮ ವ್ಯಕ್ತಿತ್ವ, ನೋಟ ಮತ್ತು ಜೀವನ ಮಾರ್ಗವನ್ನು ರೂಪಿಸುತ್ತದೆ, ಚಂದ್ರ ಮತ್ತು ಸೂರ್ಯ ರಾಶಿಗಳು ಆವರ್ತಕ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ಮಾರ್ಗದರ್ಶನ ಮಾಡುತ್ತವೆ.",
  "exact_time_critical_for_ascendant": "ನಿಖರವಾದ ಲಗ್ನ ಲೆಕ್ಕಾಚಾರಕ್ಕಾಗಿ ನಿಖರವಾದ ಜನ್ಮ ಸಮಯ ಅತ್ಯಗತ್ಯ",
  "location_essential_for_ascendant": "ನಿಮ್ಮ ಉದಯ ರಾಶಿಯನ್ನು ನಿರ್ಧರಿಸಲು ನಿಖರವಾದ ಸ್ಥಳ ಅತ್ಯಗತ್ಯ",
  "complete_ascendant_analysis": "ಸಂಪೂರ್ಣ ಲಗ್ನ ವಿಶ್ಲೇಷಣೆ",
  "rising_sign_identification": "ಉದಯ ರಾಶಿ ಗುರುತಿಸುವಿಕೆ",
  "personality_traits_analysis": "ವ್ಯಕ್ತಿತ್ವ ಲಕ್ಷಣಗಳ ವಿಶ್ಲೇಷಣೆ",
  "first_impression_insights": "ಮೊದಲ ಅನಿಸಿಕೆ ಒಳನೋಟಗಳು",
  "life_path_guidance": "ಜೀವನ ಮಾರ್ಗ ಮಾರ್ಗದರ್ಶನ",
  "focused_ascendant_analysis_note": "ನಿಮ್ಮ ಉದಯ ರಾಶಿ ಮತ್ತು ಲಗ್ನ ಲಕ್ಷಣಗಳ ಮೇಲೆ ಕೇಂದ್ರೀಕೃತ ವಿಶೇಷ ವಿಶ್ಲೇಷಣೆ.",
  "pay_and_generate_analysis": "ಪಾವತಿ ಮಾಡಿ ಮತ್ತು ವಿಶ್ಲೇಷಣೆ ರಚಿಸಿ",
  "your_rising_sign_detailed": "ನಿಮ್ಮ ಉದಯ ರಾಶಿಯ ವಿಸ್ತೃತ ವಿವರಣೆ",
  "personality_mask_analysis": "ವ್ಯಕ್ತಿತ್ವ ಮುಖವಾಡ ಮತ್ತು ಬಾಹ್ಯ ಪ್ರಸ್ತುತಿ ವಿಶ್ಲೇಷಣೆ",
  "appearance_and_style_insights": "ನೋಟ ಮತ್ತು ಶೈಲಿಯ ಒಳನೋಟಗಳು",
  "life_approach_patterns": "ಜೀವನ ವಿಧಾನ ಮತ್ತು ನಡವಳಿಕೆಯ ಮಾದರಿಗಳು",
  "sample_ascendant_analysis": "ಮಾದರಿ ಲಗ್ನ ವಿಶ್ಲೇಷಣೆ",
  "sample_ascendant_description": "ನಿಮ್ಮ ವ್ಯಕ್ತಿಗತ ಲಗ್ನ ವರದಿ ವಿಸ್ತೃತ ಒಳನೋಟಗಳೊಂದಿಗೆ ಹೇಗೆ ಕಾಣುತ್ತದೆ ಎಂಬುದು ಇದು.",
  "rising_signs": "ಉದಯ ರಾಶಿಗಳು",
  "aries_rising": "ಮೇಷ ಲಗ್ನ",
  "taurus_rising": "ವೃಷಭ ಲಗ್ನ",
  "gemini_rising": "ಮಿಥುನ ಲಗ್ನ",
  "cancer_rising": "ಕರ್ಕ ಲಗ್ನ",
  "leo_rising": "ಸಿಂಹ ಲಗ್ನ",
  "virgo_rising": "ಕನ್ಯಾ ಲಗ್ನ",
  "ascendant_analysis_processing": "ನಿಮ್ಮ ಲಗ್ನ ವಿಶ್ಲೇಷಣೆಯನ್ನು ನಮ್ಮ ಪರಿಣಿತ ಜ್ಯೋತಿಷಿಗಳು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ.",
  "detailed_ascendant_report_pdf": "ವಿಸ್ತೃತ ಲಗ್ನ ವರದಿ (PDF ಸ್ವರೂಪ)",
  "rising_sign_characteristics": "ಉದಯ ರಾಶಿ ಗುಣಲಕ್ಷಣಗಳು ಮತ್ತು ಲಕ್ಷಣಗಳು",
  "personality_presentation_insights": "ವ್ಯಕ್ತಿತ್ವ ಪ್ರಸ್ತುತಿ ಒಳನೋಟಗಳು",
  "first_impression_analysis": "ಮೊದಲ ಅನಿಸಿಕೆ ಮತ್ತು ಸಾಮಾಜಿಕ ವ್ಯಕ್ತಿತ್ವ ವಿಶ್ಲೇಷಣೆ",
  "life_approach_guidance": "ಜೀವನ ವಿಧಾನ ಮತ್ತು ನಡವಳಿಕೆಯ ಮಾರ್ಗದರ್ಶನ",
  "your_ascendant_analysis_status": "ನಿಮ್ಮ ಲಗ್ನ ವಿಶ್ಲೇಷಣೆ ಸ್ಥಿತಿ",
  "processing_your_analysis": "ನಿಮ್ಮ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಸಂಸ್ಕರಿಸುತ್ತಿದ್ದೇವೆ",
  "analysis_processing_message": "ನಮ್ಮ ಪರಿಣಿತ ಜ್ಯೋತಿಷಿಗಳು ನಿಮ್ಮ ವ್ಯಕ್ತಿಗತ ಲಗ್ನ ವಿಶ್ಲೇಷಣೆಯ ಮೇಲೆ ಕೆಲಸ ಮಾಡುತ್ತಿದ್ದಾರೆ."
}
